<template>
  <div>
    <v-btn @click.stop="openFileChooser"><v-icon class="mr-1">{{$vuetify.icons.images}}</v-icon> Get Picture</v-btn>
    <input :id="uniqueID" style="display: none;" type="file" accept="image/*" @change="handleFileChange"/>
  </div>

</template>

<script>
/* This code is a file select button to enable uploading one or more files. */
export default {
  props: {
    value: File
  },
  computed: {
    uniqueID () {
      return 'fileInput' + this._uid
    }
  },
  methods: {
    openFileChooser () {
      document.getElementById(this.uniqueID).click()
    },
    handleFileChange (e) {
      if (e.target.files.length > 0) {
        this.$emit('fileSelected', e.target.files)
      }
    }
  }
}
</script>

<style scoped>

</style>
